import React from 'react';
import CommonBanner from "../component/Common/CommonBanner";
import { ImageConstants } from "../assets/img/ImageConstants";
import StaticSEOTags from '../component/DynamicSEO/StaticSEOTags';
import Img from "../assets/img/imagination/tourall.jpg";

const HoneymoonPackages = () => {
  return (
    <>
      <StaticSEOTags
        fallbackTitle="Honeymoon Packages - Holidays Maker"
        fallbackDescription="Celebrate your new journey with romantic honeymoon packages by Holidays Maker. Tailored for every couple, with beautiful destinations and unforgettable experiences."
        fallbackKeywords="honeymoon packages, romantic getaways, newlyweds, Pakistan, Maldives, Turkey, UAE, Malaysia, Singapore, Thailand, Holidays Maker"
        fallbackOgTitle="Honeymoon Packages - Holidays Maker"
        fallbackOgDescription="Start your married life with a perfect honeymoon. Explore our curated honeymoon packages for couples."
        fallbackCanonicalUrl="https://poliflytravels.com/honeymoon-packages/"
      />
      <CommonBanner
        heading="Honeymoon Packages"
        img={ImageConstants.visabanner}
        pagination="Honeymoon Packages"
      />
      <section className="honeymoon-packages-area pt-5 pb-5 mt-5 mb-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="content-wrapper visa-content">
                <h2 className="mb-4">Honeymoon Packages - Creating Beautiful Beginnings for Newlyweds</h2>
                <p className="lead">Celebrate the beginning of your new journey with a perfect honeymoon getaway. At Holidays Maker, we craft romantic honeymoon packages that blend comfort, luxury, and unforgettable memories.</p>
                <div className="mb-5">
                  <h3 className="mb-3">Tailored for Every Couple</h3>
                  <p>Whether you dream of a peaceful escape in the hills or a romantic beach holiday, we have something for everyone. Our packages are designed to suit your preferences, travel style, and budget.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
            <img src={Img} alt="img" />
            </div>

          </div>
          <div className='row mt-5 pb-5'>
            <div className='col-lg-6'>
            <div className="mb-5">
                  <h3 className="mb-3">Popular Honeymoon Destinations</h3>
                  <div className="row">
                    <div className="col-md-12">
                      <h4>Within Pakistan:</h4>
                      <ul className="benefits-list">
                        <li>Hunza, Skardu, Swat, Murree, Naran & Kaghan</li>
                        <li>Comfortable stays, scenic views, and peaceful vibes</li>
                        <li>Maldives, Turkey, UAE, Malaysia, Singapore, Thailand, and can be Customised</li>
                        <li>Romantic resorts, guided tours, and complete travel support</li>
                      </ul>
                    </div>
                
                  </div>
                </div> 
                </div>
            <div className='col-lg-6'>  
            <div className="mb-5">
                  <h3 className="mb-3">What's Included</h3>
                  <ul className="benefits-list">
                    <li>Flight or transport bookings</li>
                    <li>Hotel/resort stays with honeymoon setups</li>
                    <li>Sightseeing and special couple activities</li>
                    <li>Visa assistance (for international packages)</li>
                    <li>Personalized support from planning to travel</li>
                  </ul>
                </div>
              
            </div>
          </div>

          <div className='row'>
            <div className='col-lg-12'>
        
                <div className="mb-5">
                  <h3 className="mb-3">Why Choose Holidays Maker?</h3>
                  <ul className="benefits-list">
                    <li>Carefully designed romantic itineraries</li>
                    <li>Handpicked destinations for newlyweds</li>
                    <li>Affordable pricing with no hidden costs</li>
                    <li>Friendly and experienced travel consultants</li>
                  </ul>
                </div> </div>
         
          </div>
         
          <div className='row'>
          
            <div className='col-lg-12'>  
          
                <div className="get-in-touch mb-5">
                  <h3 className="mb-3">Start your new life with unforgettable moments — leave the planning to us.</h3>
               
                </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HoneymoonPackages;